module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-67-min.36f08287.jpg";